import { Box, Button, Card, CardActions, CardContent, Container, Stack, Typography } from "@mui/material";
import Header from "../../components/Shared/Header";
import Footer from "../../components/Shared/Footer";
import HeroSection from "../../components/Sections/Hero";

export default function Homepage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection
          eyebrow="MultiSite WP"
          title="Ein Standard-Design, das sich je Kunde flexibel branden laesst"
          subtitle="Material-basierte Komponenten, die ihr pro Kunde mit Farben, Typo und Layout-Details ueberschreiben koennt."
          ctaLabel="Demo anfragen"
          ctaHref="/kontakt"
        />
        <Box sx={{ py: { xs: 6, md: 8 } }}>
          <Container maxWidth="lg">
            <Stack spacing={2} sx={{ mb: 4, maxWidth: 640 }}>
              <Typography variant="h2">Toller Start fuer neue Kunden</Typography>
              <Typography variant="body1" color="text.secondary">
                Header, Hero, Sections, Grids, Cards, Footer, Menu und Forms sind als Basiskomponenten vorbereitet
                und koennen pro Kunde ueber Themes und Overrides individualisiert werden.
              </Typography>
            </Stack>
            <Box
              sx={{
                display: "grid",
                gap: 3,
                gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }
              }}
            >
              {[
                { title: "Schneller Go-Live", text: "Eine solide Material-Basis, direkt einsatzbereit." },
                { title: "Corporate Branding", text: "Farben, Typo, Radius und Shadows je Kunde steuerbar." },
                { title: "WP-Content Ready", text: "Sections lassen sich sauber auf WP-Blocks mappen." }
              ].map((card) => (
                <Box key={card.title}>
                  <Card>
                    <CardContent>
                      <Typography variant="h5" sx={{ mb: 1 }}>
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {card.text}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ px: 2, pb: 2 }}>
                      <Button size="small" color="primary">
                        Mehr erfahren
                      </Button>
                    </CardActions>
                  </Card>
                </Box>
              ))}
            </Box>
          </Container>
        </Box>
      </main>
      <Footer />
    </>
  );
}
